
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title: "Comment améliorer et soigner l'image de votre entreprise",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Découvrez comment renforcer l’image de marque de votre entreprise pour attirer plus de clients, assurer sa croissance et bâtir une réputation solide et durable.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Comment améliorer son image de marque ?",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Une entreprise en quête de visibilité, de croissance et de longévité doit construire et soigner son image de marque. Elle a ainsi intérêt à connaître ses atouts et ses clients. Cet article vous explique tout !",
        },
      ],
    };
  },
};
